export default __webpack_public_path__ + "static/media/infosys2.7b30885f.PNG";